<div id="planning_week">
    @for(day of this.days; track $index){
        <div class="planning_week_day">
            <div class="planning_week_day_infos" [class.today]="day.today">                
                <div class="planning_week_day_label">{{day.date | marvDateToString: 'dddd DD/MM'}}</div>               
            </div>
            <div class="planning_week_day_items">
                
                @if(day.operations.length > 0){
                    <div class="planning_week_day_operations">
                        @for(operation of day.operations; track $index){
                            <marv-tag size="small" [color]="this.missionTypeService.getColor(operation.typeOfMission)">{{operation.name}} <span>({{operation.nbMissions}})</span></marv-tag>
                        }
                    </div>
                }
                
                @if(day.planningItems.length > 0){
                    @for(planningItem of day.planningItems; track $index){
                        <app-planning-item [planningItem]="planningItem" (onSelectPlanningItem)="this.selectPlanningItem($event)"/>
                    }
                }
                @else {
                    <marv-message type="info">{{'MSG_NO_MISSION_PLANNING' | translate}}</marv-message>
                }
            </div>
        </div>
    }
</div>